module.exports = __webpack_public_path__ + "img/7.05c01478.jpeg";